module.exports = __webpack_public_path__ + "static/the-guarded-gate-0e61c1c0c26c1e93211bc75f4181d01d.jpg";